module.exports = __webpack_public_path__ + "static/media/first-signup.fd2f585a.svg";